//import external libraries
import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

//import internal services and resources
import { getProjectItemHydra } from "../../../utils/services/projectService";
import { appCtx } from "../../../utils/hooks/appContext";

//import MUI components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ViewListIcon from "@mui/icons-material/ViewList";
import useTheme from "@mui/material/styles/useTheme";

const ProjectItemsHydraTable = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const { projectId } = useContext(appCtx);
  let pId = props.projectId;

  useEffect(() => {
    if (props.projectId == null) pId = projectId;

    getProjectItemHydra(pId).then((res) => {
      if (res.statusCode >= 200 && res.statusCode < 300) {
        const projectsItem = Array.isArray(res.data) ? res.data : [];

        setRows(
          projectsItem.map((projectItem) => {
            let projItem = {
              id: projectItem.id,
              price: projectItem.price,
              name: projectItem.name,
              poolName: projectItem.poolName,
              typeOfPool: projectItem.typeOfPool,
              poolVolume: projectItem.poolVolume,
              waterSurface: projectItem.waterSurface,
              airTemperature: projectItem.airTemperature,
              waterTemperature: projectItem.waterTemperature,
              maxRequiredAir: projectItem.maxRequiredAir,
              minRequiredFreshAir: projectItem.minRequiredFreshAir,
              numOfAirChanges: projectItem.numOfAirChanges,
              airHumidity: projectItem.airHumidity,
              absoluteHumiditySupplyAir: projectItem.absoluteHumidityAir,
              //  Attractions
              wildWaterChannels: projectItem.wildWaterChannels,
              waterMushrooms: projectItem.waterMushrooms,
              waterMushroomsMeters: projectItem.waterMushroomsMeters,
              neckMassageShowers: projectItem.neckMassageShowers,
              underwaterJets: projectItem.underwaterJets,
              bubbleFountains: projectItem.bubbleFountains,
              childrenSeats: projectItem.childrenSeats,
              childrenSlides: projectItem.childrenSlides,
              massageAreas: projectItem.massageAreas,
              loungersSeats: projectItem.loungersSeats,
              simultaneityFactorAttraction:
                projectItem.simultaneityFactorAttraction,
              numberOfVisitors: projectItem.numberOfVisitors,
              numOfUnits: projectItem.numOfUnits,
              unitTypeId: projectItem.unitTypeId,
            };
            return projItem;
          })
        );
      }
    });
  }, []);

  const RenderButtonOpen = (id) => {
    return (
      <Button
        onClick={() => {
          window.scrollTo(0, 0);
          openRevisions(id);
          // navigate("/hydra", { state: rows[0] });
        }}
      >
        <FolderOpenIcon sx={{ color: theme.palette.primary.main }} />
      </Button>
    );
  };

  const openRevisions = (id) => {
    window.scrollTo(0, 0);
    navigate("/hydra/project-item", {
      state: { id: id.row.id },
    });
  };

  const columns = [
    {
      field: "btnOpen",
      headerName: t("projectTableheaderName.open"),
      minWidth: 70,
      renderCell: RenderButtonOpen,
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-style",
      headerAlign: "center",
    },
    {
      field: "id",
      headerName: "ID",
      minWidth: 60,
      align: "center",
      headerAlign: "center",
      headerClassName: "header-style",
    },
    {
      field: "name",
      headerName: t("projectitem.fieldName"),
      minWidth: 210,
      headerAlign: "center",
      align: "center",
      headerClassName: "header-style",
    },
    {
      field: "price",
      headerName: t("projectitem.price"),
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: ({ value }) => `${value.toFixed(2)} €`,
      headerClassName: "header-style",
    },
    {
      field: "poolName",
      headerName: t("hydraPro.poolName"),
      minWidth: 140,
      headerAlign: "center",
      align: "center",
      headerClassName: "header-style",
    },
    {
      field: "typeOfPool",
      headerName: t("hydraPro.poolTypeTable"),
      type: "number",
      minWidth: 120,
      align: "center",
      headerClassName: "header-style",
      headerAlign: "center",
    },
    {
      field: "poolVolume",
      headerName: t("hydraPro.poolVolume"),
      type: "number",
      minWidth: 250,
      align: "center",
      headerClassName: "header-style",
      headerAlign: "center",
    },
    {
      field: "waterSurface",
      headerName: t("hydraPro.waterSurface"),
      minWidth: 260,
      headerClassName: "header-style",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "airTemperature",
      headerName: t("hydraPro.airTemp"),
      minWidth: 280,
      headerClassName: "header-style",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "waterTemperature",
      headerName: t("hydraPro.waterTemp"),
      minWidth: 260,
      headerClassName: "header-style",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "maxRrequiredAir",

      headerName: t("hydraPro.maxRequiredAir"),
      minWidth: 300,
      headerClassName: "header-style",
      align: "center",
      headerAlign: "center",
    },

    {
      field: "minRequiredFreshAir",
      headerName: t("hydraPro.minRequiredFreshAir"),
      minWidth: 340,
      headerClassName: "header-style",
      align: "center",
      headerAlign: "center",
    },

    {
      field: "numOfAirChanges",
      headerName: t("hydraPro.numOfAirChanges"),
      minWidth: 330,

      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-style",
    },
    {
      field: "airHumidity",
      headerName: t("hydraPro.airHumid"),
      minWidth: 290,

      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-style",
    },
    {
      field: "numOfUnits",
      headerName: t("hydraPro.numberOfUnits"),
      minWidth: 170,

      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-style",
    },
  ];

  return (
    rows.length > 0 && (
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <ViewListIcon sx={{ width: 50, height: 50, m: 1 }} />
          <Typography component="h1" variant="h4" sx={{ margin: 2 }}>
            {t("projectitem.tabname")} HYDRA | pro
          </Typography>
        </Box>
        <DataGrid
          rows={rows}
          columns={columns}
          // autoPageSize
          autoHeight
          rowsPerPageOptions={[10, 20, 100]}
          sx={{
            ".MuiDataGrid-columnHeaders": {
              backgroundColor: theme.palette.secondary.main,
            },
            ".MuiTablePagination-select": {
              "margin-top": "-3px",
            },
            ".MuiTablePagination-selectIcon": {
              "margin-top": "-3px",
            },
            ".MuiDataGrid-columnHeaderTitle.css-1jbbcbn-MuiDataGrid-columnHeaderTitle":
              {
                fontWeight: "bold",
                paddingLeft: "5px",
              },
          }}
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {t("projectitemrevision.noRows")}
              </Stack>
            ),
          }}
          localeText={{
            MuiTablePagination: {
              labelRowsPerPage: t("tableRows.rowsPerPage"),
              labelDisplayedRows: ({ from, to, count }) =>
                `${from} - ${to} ${t("tableRows.of")} ${count}`,
            },
          }}
          // onSelectionModelChange={(newSelectionModel) => {
          //   setSelectionModel(newSelectionModel);
          // }}
          // selectionModel={selectionModel}
          // {...rows}
        />
      </Box>
    )
  );
};

export default ProjectItemsHydraTable;
